export default __webpack_public_path__ + "static/media/coin_base.b603dad8.png";